<template>
    <div id="VendorPurchaseOrderView">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
            <div class="right-asset-tab-list purchase-order-right-tab">
                <div id="tabs" class="containerTab mb-3">
                    <div class="tabs">
                        <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">PO Details</a>
                        <a v-on:click="activityLogs()" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Activity</a>
                    </div>
                    <div class="content">
                        <div v-show="activetab === 1" class="tabcontent">
                            <div class="list-view">
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                    <label class="col">#PO:</label>
                                    <span class="col">{{poNum}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flbill"></i> </span> -->
                                    <label class="col">Order Type:</label>
                                    <span class="col">{{po_type}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flman-user"></i> </span> -->
                                    <label class="col">Vendor:</label>
                                    <span class="col">{{vendor}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-fltime-saving"></i> </span> -->
                                    <label class="col">Status:</label>
                                    <span class="col">{{woStatus}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flcalendar2"></i> </span> -->
                                    <label class="col">Ordering:</label>
                                    <span class="col">{{orderingLoc}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-fldelivery-truck "></i> </span> -->
                                    <label class="col">Assigned:</label>
                                    <span class="col">{{assignLoc}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <!-- <span class="work-order-icon"> <i class="hi-icon icon-flplaceholder-filled-point hi-icon icon-fldelivery-truck "></i> </span> -->
                                    <label class="col">Ship To:</label>
                                    <span class="col">{{shipToLoc}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Order Date:</label>
                                    <span class="col">{{order_date}}</span>
                                </div>
                                <!-- <div class="row form-group pl-3 pr-3">
                                    <label class="col">Due Date:</label>
                                    <span class="col">{{due_date}}</span>
                                </div> -->
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Delivery Date:</label>
                                    <span class="col">{{delivery_date}}</span>
                                </div>
                                <template v-if="po_type == 'Equipment-osr'">
                                  <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                      <label class="col">Unit #:</label>
                                      <span class="col">{{unit_no}}</span>
                                  </div>
                                  <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                      <label class="col">Vendor Unit #:</label>
                                      <span class="col">{{vendor_unit_no}}</span>
                                  </div>
                                  <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                      <label class="col">VIN:</label>
                                      <span class="col">{{vin}}</span>
                                  </div>
                                  <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                      <label class="col">Attention:</label>
                                      <span class="col">{{attention}}</span>
                                  </div>
                                </template>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Total:</label>
                                    <span class="col">{{total}}</span>
                                </div>
                                <div class="row form-group border-bottom pb-2 pl-3 pr-3">
                                    <label class="col">Notes:</label>
                                    <span class="col">{{notes}}</span>
                                </div>
                            </div>
                        </div>
                        <div v-show="activetab === 2" class="tabcontent" id="customer-activity-logs" >
                            <estimate-activity-log-list :activityLogVal="activityLogsTabValue"></estimate-activity-log-list>
                        </div>
                    </div>
                </div>
            </div>
        <div id="page-content-wrapper" class="admin-content-area left-asset-detail-section purchase-order-left-section">
            <template v-if="cantAccessPage === true">
                <div class="page-name asset-view-page-name purchase-order-title">
                    <div class="page-title">Vendor PO View</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <div class="web-action-btn btn-groups text-right">
                            <button v-if="(po_type == 'Item' || po_type == 'Misc') && isProcessed == 1 && qty_matched == 0" type="submit" id="createrecordreceipt" v-on:click="recordReceipt()" class="btn btn-primary" >Record Receipt
                            </button>
                            <!-- <button v-if="po_type == 'Item' && isProcessed == 1 && billCreated != 'yes' && woStatus != 'Closed'" type="submit" id="createvendorinvoice" v-on:click="vendorInvoice()" class="btn btn-primary" >Vendor Invoice
                            </button> -->
                            <button type="submit"  v-if="isProcessed == 0 && woStatus != 'Closed'" id="ProcessPO" v-on:click="processPo('process')" class="btn btn-primary" >Process
                            </button>
                            <button type="submit"  v-if="isProcessed == 1 && woStatus != 'Closed'" id="UnProcessPO" v-on:click="processPo('unprocess')" class="btn btn-primary" > Un Process
                            </button>
                            <template v-if="po_type.toLowerCase() == 'sublet po'">
                                <button type="submit" v-if="isProcessed == 0 && (woStatus == 'Open' || woStatus == 'Reserved') && woType == 'default'" id="editWorkOrderEstimateBtn" v-on:click="editPurchaseOrder()" class="btn btn-secondary"><i class="fp-edit-icon"></i>  Edit</button>
                            </template>
                            <template v-else>
                                <button type="submit" v-if="isProcessed == 0 && (woStatus == 'Open' || woStatus == 'Reserved')" id="editWorkOrderEstimateBtn" v-on:click="editPurchaseOrder()" class="btn btn-secondary"><i class="fp-edit-icon"></i>  Edit</button>
                            </template>
                            <template v-if="poReceiptsArr.length != 0">
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="previewBarcode()">
                                <i class="fp-print"></i> Preview Barcode
                            </a>
                            </template>
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="downloadPurchaseOrder"> <i class="fp-download"></i> Download</a>
                            <a href="javascript:void(0)" class="btn btn-primary" v-on:click="sendPo"> <i class="fp-send-message"></i> Send</a>
                            <!-- <router-link class="btn btn-secondary" v-bind:to="{path: backPageUrl}">
                                <i class="fp-back"></i>  Back
                            </router-link> -->
                            <button type="submit" class="btn btn-secondary" v-on:click.prevent="backBtn()" >
                                <i class="fp-back"> </i> Back
                            </button>
                        </div>
                        <div class="mobile-action-btn elipse-btn">
                            <button type="submit" id="editWorkOrderEstimateBtn" v-on:click="editPurchaseOrder()" class="btn btn-secondary"><i class="fp-edit-icon"></i>  Edit</button>
                            <button type="submit" class="btn btn-secondary" v-on:click.prevent="backBtn()" >
                                <i class="fp-back"> </i> Back
                            </button>
                            <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="true" v-on:click.prevent="myFunction">
                                <i class="fp-ellipsis-v"></i>
                            </button>
                            <div id="myDropdown" class="dropdown-content">
                                <ul>
                                    <li>
                                        <a href="javascript:void(0)" class="" v-on:click="downloadPurchaseOrder">  Download</a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0)" class="" v-on:click="sendPo">  Send</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-if="!showBarcode" class="container-fluid">
                        <div class="admin-page-content vendor-purchase-order">
                        <section class="internal-container">
                            <div id="tabs" class="containerTab mt-3">
                                <div class="tabs">
                                    <a v-on:click="detail_tab=1" v-bind:class="[ detail_tab === 1 ? 'active' : '' ]">Line Detail</a>
                                    <a v-if="po_type.toLowerCase() == 'item' || po_type.toLowerCase() == 'misc'" v-on:click="detail_tab=2" v-bind:class="[ detail_tab === 2 ? 'active' : '' ]">Receipt Detail</a>
                                    <a v-if="canViewGL && glArr.length > 0" v-on:click="detail_tab=3" v-bind:class="[ detail_tab === 3 ? 'active' : '' ]">GL Detail</a>
                                </div>
                                <div class="content">
                                    <div v-show="detail_tab === 1" class="tabcontent">
                                        <template v-if="purchaseOrderItemsArr.length == 0">
                                            <div class="lineitem-main-section">
                                                <h5>No Line Item Added</h5>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="table-responsive-sm">
                                                <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="purchaseOrderItemsArr != undefined && purchaseOrderItemsArr.length > 0">
                                                    <thead>
                                                        <tr class="table-primary">
                                                            <th v-if="po_type == 'Equipment'"></th>
                                                            <!-- <th v-if="po_type.toLowerCase() != 'sublet po'">Type</th> -->
                                                            <th v-if="!showItemsColumn">Manufacturer</th>
                                                            <th v-if="!showItemsColumn">Model</th>
                                                            <th v-if="!showItemsColumn">Pool</th>
                                                            <th v-if="!showItemsColumn">Year</th>
                                                            <th v-if="woType == 'multi unit'">Unit No.</th>
                                                            <th v-if="woType == 'multi unit'">#Wo</th>
                                                            <th v-if="woType == 'multi unit'">Line Number</th>
                                                            <th v-if="showItemsColumn && (po_type.toLowerCase() != 'sublet po' && po_type.toLowerCase() != 'misc')">Part</th>
                                                            <th v-if="showItemsColumn && (po_type.toLowerCase() == 'sublet po' || po_type.toLowerCase() == 'misc')">Description</th>

                                                            <th class="text-right" v-if="po_type.toLowerCase() != 'sublet po'">Qty/Hours</th>
                                                            <th class="text-right" v-if="po_type.toLowerCase() != 'sublet po'">Unit Price</th>
                                                            <!-- <th class="text-right">Tax (%)</th> -->
                                                            <th class="text-right">Amount</th>
                                                            <th v-if="showItemsColumn && (po_type.toLowerCase() == 'misc')">GL Account</th>
                                                            <th v-if="showItemsColumn && (po_type.toLowerCase() == 'item')">Unit No.</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in purchaseOrderItemsArr" v-bind:key="index">
                                                            <td v-if="po_type == 'Equipment'">
                                                                <div class="checkbox">
                                                                    <label class="custome-checkbox">
                                                                        <!-- <input data-v-3c5d4e02="" type="checkbox" id="itemIndex0" name="estimation_selection0">  -->
                                                                        <input type="checkbox" :id="'itemIndex'+index" :name="'estimation_selection'+index" @change="selectionForOrder($event,item,index)" v-model="item.itemSelection">
                                                                        <span data-v-3c5d4e02="" class="checkmark"></span>
                                                                    </label>
                                                                </div>
                                                            </td>
                                                            <!-- <td v-if="po_type.toLowerCase() != 'sublet po' && item.charge_id != null">{{ item.charge_id.text }}</td> -->
                                                            <td v-if="!showItemsColumn"> {{ item.manufacture_id.text}} </td>
                                                            <td v-if="!showItemsColumn"> {{ item.model_id.text}} </td>
                                                            <td v-if="!showItemsColumn"> {{ item.asset_pool_id.text}} </td>
                                                            <td v-if="!showItemsColumn"> {{ item.year}} </td>
                                                            <td v-if="woType == 'multi unit'"> <p v-if="item.vehicle_id.text">{{ item.vehicle_id.text}}</p><p v-else>-</p> </td>
                                                            <td v-if="woType == 'multi unit'"> <p v-if="item.wo_number">{{ item.wo_number}}</p><p v-else>-</p> </td>
                                                            <td v-if="woType == 'multi unit'"> <p v-if="item.line_number">{{ item.line_number}}</p><p v-else>-</p> </td>
                                                            <td v-if="showItemsColumn && (po_type.toLowerCase() != 'sublet po' && po_type.toLowerCase() != 'misc')"> <p v-if="item.part.text">{{ item.part.text}}</p><p v-else>-</p> </td>
                                                            <td v-if="showItemsColumn && (po_type.toLowerCase() == 'sublet po' || po_type.toLowerCase() == 'misc')"> <p v-if="item.description">{{ item.description}}</p><p v-else>-</p> </td>
                                                            <td align="right" v-if="po_type.toLowerCase() != 'sublet po'"> {{ item.quantity}} </td>
                                                            <template v-if="item.unit_price_format != undefined && item.unit_price_format != null">
                                                                <td align="right" v-if="po_type.toLowerCase() != 'sublet po'"> {{ item.unit_price_format}} </td>
                                                            </template>
                                                            <template v-else>
                                                                <td align="right" v-if="po_type.toLowerCase() != 'sublet po'"> ${{ item.unit_price}} </td>
                                                            </template>
                                                            <!-- <td class="text-right"> {{ item.tax_percentage}} </td> -->
                                                            <template v-if="item.total_format != undefined && item.total_format != null">
                                                                <td align="right"> {{ item.total_format}} </td>
                                                            </template>
                                                            <template v-else>
                                                                <td align="right"> ${{ item.total.toFixed(2)}} </td>
                                                            </template>
                                                            <td v-if="showItemsColumn && (po_type.toLowerCase() == 'misc')"> <p v-if="item.gl_account_id.text">{{ item.gl_account_id.text}}</p><p v-else>-</p> </td>
                                                            <td v-if="showItemsColumn && (po_type.toLowerCase() == 'item')"> <p v-if="item.vehicle_id.text">{{ item.vehicle_id.text}}</p><p v-else>-</p> </td>
                                                        </tr>
                                                        <!-- <tr>
                                                            <td :colspan="showItemsColumn ?'3':'5'" rowspan="2"></td>
                                                            <td class="table-secondary table-title" colspan="2">Subtotal</td>
                                                            <td align="right" class="table-secondary">${{subTotal.toFixed(2)}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td class="table-secondary table-title" colspan="2">Total</td>
                                                            <td align="right" class="table-secondary order-total">${{total.toFixed(2)}}</td>
                                                        </tr> -->
                                                    </tbody>
                                                </table>
                                            </div>
                                        </template>
                                        <hr class="light-hr"/>
                                        <template v-if="purchaseOrderReadingArr.length > 0">
                                            <div class="table-responsive-sm">
                                                <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="purchaseOrderItemsArr != undefined && purchaseOrderItemsArr.length > 0">
                                                    <thead>
                                                        <tr class="table-primary">
                                                            <th>Section</th>
                                                            <th>Reading Date</th>
                                                            <th>Reading</th>
                                                            <th>Unit</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in purchaseOrderReadingArr" v-bind:key="index">
                                                            <td> {{ item.section_name}} </td>
                                                            <td> {{ item.reading_date}} </td>
                                                            <td> {{ item.reading}} </td>
                                                            <td> {{ item.measurment_unit}} </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </template>
                                        <template v-if="po_type.toLowerCase() != 'sublet po' && po_type != 'Equipment-osr'">
                                        <template v-if="chargeItemArr.length == 0">
                                            <div class="lineitem-main-section">
                                                <h5>No Charge Item Added</h5>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="table-responsive-sm">
                                                <table aria-describedby="table" id="contact_table" class="table table-bordered table-sm font-1" v-if="chargeItemArr != undefined && chargeItemArr.length > 0">
                                                    <thead>
                                                        <tr class="table-primary">
                                                            <th>Charge</th>
                                                            <th class="text-right">Qty/Hours</th>
                                                            <th class="text-right">Unit Price</th>
                                                            <th class="text-right">Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(charge, chindex) in chargeItemArr" v-bind:key="chindex">
                                                            <td> <p v-if="charge.charge_id.text">{{ charge.charge_id.text}}</p><p v-else>-</p> </td>
                                                            <td class="text-right"> {{ charge.quantity}} </td>
                                                            <td class="text-right"> {{ currencyFormat(charge.unit_price,3)}} </td>
                                                            <td class="text-right"> {{ currencyFormat(charge.total,3)}} </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </template>
                                        </template>
                                        <div class="order-summary mt-4" v-if="showTotalSummary">
                                            <div class="row">
                                                <div class="col-md-5 offset-md-7">
                                                    <div class="">
                                                        <label class="font-bold"> SUMMARY </label>
                                                        <table aria-describedby="table" class="table table-sm table-bordered">
                                                            <tr>
                                                                <td> Subtotal: </td>
                                                                <!-- <td class="text-right"> ${{subTotal.toFixed(2)}} </td> -->
                                                                <td class="text-right"> {{subTotal}} </td>
                                                            </tr>
                                                            <tr class="table-secondary">
                                                                <td> Total: </td>
                                                                <!-- <td class="order-total text-right"> ${{total.toFixed(2)}} </td> -->
                                                                <td class="order-total text-right"> {{total}} </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-show="detail_tab === 2" class="tabcontent">
                                        <template v-if="poReceiptsArr.length == 0">
                                            <div class="lineitem-main-section">
                                                <h5>No Receipt Added</h5>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="table-responsive-sm">
                                                <table aria-describedby="table" id="contact_table" class="table table-sm table-bordered font-1" v-if="poReceiptsArr != undefined && poReceiptsArr.length > 0">
                                                    <thead>
                                                        <tr class="table-primary">
                                                            <th class="text-center">#Receipt</th>
                                                            <th class="text-center">#Invoice</th>
                                                            <th class="text-center">#Voucher</th>
                                                            <th class="text-center">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(ritem, ind) in poReceiptsArr" v-bind:key="ind">
                                                            <td class="text-center">
                                                                <template v-if="canViewPurchaseOrderReceipt">
                                                                    <router-link title="View Receipt" class="color-blue" v-bind:to="{name: 'RecordReceiptView',params:{id:ritem.receipt_id},query:{fromUrl:fromUrl}}">{{ritem.receipt_no}}</router-link>
                                                                </template>
                                                                <template v-else>
                                                                    <span>{{ritem.receipt_no}}</span>
                                                                </template>
                                                            </td>
                                                            <template v-if="ritem.bill_found == 1">
                                                                <td class="text-center">{{ritem.bill_number}}</td>
                                                                <td class="text-center">
                                                                    <template v-if="canViewVendorInvoice">
                                                                        <router-link title="View Vendor Invoice" class="color-blue" v-bind:to="{name: 'BillView',params:{id:ritem.bill_id},query:{fromUrl:fromUrl}}">{{ritem.voucher_number}}</router-link>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span>{{ritem.voucher_number}}</span>
                                                                    </template>
                                                                </td>
                                                                <td class="text-center"> - </td>
                                                            </template>
                                                            <template v-else>
                                                                <td class="text-center"> - </td>
                                                                <td class="text-center"> - </td>
                                                                <td class="text-center">
                                                                    <template v-if="canAddVendorInvoice">
                                                                        <button id="addPOInvoiceBtn" v-on:click.prevent="addVendorInvoice(ritem.receipt_id,ritem.po_id)" class="btn btn-primary">Add Invoice</button>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span>-</span>
                                                                    </template>
                                                                </td>
                                                            </template>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </template>
                                    </div>
                                    <div v-show="detail_tab === 3" class="tabcontent">
                                        <template v-for="(glType , glTypeKey) in glArr">
                                            <template v-if="glType.type != undefined && glType.type != null">
                                                <template v-if="glType.detail != undefined && glType.detail.length > 0">
                                                    <div class="journal-title" :key="glType.type + glTypeKey">
                                                        <h5> {{glType.type}} <i class="fp-down-arrow cursor-pointer" data-toggle="collapse" :data-target="'#detailpo'+glTypeKey"></i>   </h5>
                                                    </div>
                                                    <div :id="'detailpo'+glTypeKey" class="accordian-body collapse show" :key="'detailpo'+glTypeKey">
                                                        <div class="table-reponsive-sm">
                                                            <table aria-describedby="table" id="contact_table" class="table table-bordered">
                                                                <thead>
                                                                    <tr class="table-primary">
                                                                        <th>Account</th>
                                                                        <th class="text-right">Debit</th>
                                                                        <th class="text-right">Credit</th>
                                                                        <th class="text-right">Amount</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody v-if="glType.detail != undefined && glType.detail.length > 0">
                                                                    <template v-for="(glItem , glKey) in glType.detail">
                                                                            <tr :key="'gl'+glKey">
                                                                                <template v-if="glItem.account_description == 'Total'">
                                                                                    <td class="text-right">{{glItem.account_description}}</td>
                                                                                </template>
                                                                                <template v-else>
                                                                                    <td>{{glItem.account_description}}</td>
                                                                                </template>
                                                                                <td class="text-right">{{glItem.debit}}</td>
                                                                                <td class="text-right">{{glItem.credit}}</td>
                                                                                <td class="text-right">{{glItem.journal_amount}}</td>
                                                                            </tr>
                                                                    </template>
                                                                </tbody>
                                                                <tbody v-else>
                                                                    <tr>
                                                                        <td colspan="4"><h5>No Data Found</h5></td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
                <div v-else>
                    <template>
                        <div>
                            <app-component-barcode :selected="selectedRows" :selectedflag="selectedRows_data" flagPage='viewpo'></app-component-barcode>
                        </div>
                    </template>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import Vue from "vue";



    import {commonMixins} from '../mixins/commonMixins';
    import ActivityLogListView from '@/components/ActivityLogList.vue';
    import EventBus from "././event-bus";
    Vue.component("estimate-activity-log-list", ActivityLogListView);


    export default {
        name: "VendorPurchaseOrderView",
        components: {

            appComponentBarcode: () => import('@/components/ComponentBarcode'),
        },
        mixins:[commonMixins],

        data: () => ({
            purchaseOrderReadingArr: [],
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            loading:false,
            permit_value:false,
            addPermit:false,
            assetId:"",
            selectedFile:"",
            poId:"",
            poNum:"",
            vendor:"",
            orderingLoc:"",
            assignLoc:"",
            shipToLoc:"",
            unitPrice:0,
            taxAmount:0,
            chargesTotal:0,
            taxTotal:0,
            delivery_date:"",
            order_date:"",
            due_date:"",
            po_type:"",
            customer:"",
            notes:"",
            attention:"",
            sales_person:"",
            woStatus:"",
            listDis:true,
            grandTotal:0,
            subTotal:0,
            totalTax:0,
            total:0,
            purchaseOrderItemsArr:[],
            showItemsColumn:true,
            activetab: 1,
            activityLogsTabValue: "vendorpoloadList",
            activityLoaded:false,
            selecttaskArr:[],
            order_location_id:0,
            assign_location_id:0,
            ship_to_location_id:0,
            isProcessed:0,
            backPageUrl:"/order-history/list",
            pageKey:"",
            chargeItemArr:[],
            showTotalSummary:false,
            unit_no: '',
            vendor_unit_no: '',
            vin: '',
            receiptCreated:'no',
            billCreated:'no',
            canViewGL:false,
            glArr:[],
            woType:'',
            qty_matched:1,
            poReceiptsArr:[],
            detail_tab:1,
            canAddVendorInvoice:false,
            canViewPurchaseOrderReceipt:false,
            canViewVendorInvoice:false,
            fromUrl:"",
            selectedRows:[],
            selectedRows_data:[],
            showBarcode:false,
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'view_purchase_order') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'view_general_ledger') {
                            self.canViewGL = true;
                        }
                        if (permissions[i].name == 'add_vendor_invoice') {
                            self.canAddVendorInvoice = true;
                        }
                        if (permissions[i].name == 'view_purchase_order_receipt') {
                            self.canViewPurchaseOrderReceipt = true;
                        }
                        if (permissions[i].name == 'view_vendor_invoice') {
                            self.canViewVendorInvoice = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },

        mounted: function() {
            var self = this;

            if ( window.location.search == "?from=asset" ) {
                self.backPageUrl = "/asset-purchase-order/list"
            }
            if ( window.location.search == "?from=requisition" ) {
                self.backPageUrl = "/asset-requisition/list"
            }
            if ( window.location.search == "?from=vendor_est" ) {
                self.backPageUrl = "/estimate?from=vendor"
            }
            self.fromUrl = btoa(window.location.pathname);

            self.getPermissions();
            self.loadPurchaseOrder();

            var pathUrl = window.location.pathname;
            var segments = pathUrl.split("/");
            self.pageKey='_vendor_po_view_'+segments[3];
            self.subKey1='_vendor_po_item_view_'+segments[3];

            if (self.$route.query.from){
                if (self.$route.query.from.includes('-')){
                    var woId = self.$route.query.from.split('-');
                    self.woId = woId[1];
                }
            }

        },
        metaInfo() {
            return{
                title: (this.poNum != "")? this.poNum + " | Vendor Purchase Order View | " +process.env.COPYRIGHT_NAME:"Vendor Purchase Order View | " +process.env.COPYRIGHT_NAME
            }
        },
        methods: {

            backBtn() {
                var self = this;
                var url = "/order-history/list"
                if ( self.$route.query.fromUrl != "" && self.$route.query.fromUrl != undefined ) {
                    url = atob(self.$route.query.fromUrl);
                }else if ( self.$route.query.from != undefined && self.$route.query.from == "gl") {
                    url = "/report/general-ledger";
                }
                self.redirectPageUrl(url);
            },
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            editPurchaseOrder(){
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.$router.push("/vendor-purchase-order/edit/" + segments[3]);
            },

            loadPurchaseOrder() {

                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/vendor-purchase-order/"+segments[3],
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {

                            self.poNum = data.content.po_no;
                            if (data.content.type.toLowerCase() == "sublet_po") {
                                self.po_type = "Sublet PO";
                            }else{
                                self.po_type = data.content.type;
                            }
                            var storeObject={visited_page: {
                                    path : "vendor-purchase-order |" +data.content.po_no,
                                    data : window.location.pathname,
                                    }};
                            self.getRecentlyPagesMethod(storeObject);
                            self.from_where = data.content.from_where;
                            if(data.content.type == "Item" || data.content.type.toLowerCase() == "sublet_po" || data.content.type.toLowerCase() == "misc"){
                                self.showItemsColumn = true;
                            }else{
                                self.showItemsColumn = false;
                            }
                            if(data.content.cusName != null){
                                self.customer = data.content.cusName+" ("+data.content.cusCode+")";
                            }else{
                                self.customer = "-"
                            }
                            if(data.content.vendorName != null){
                                self.vendor = data.content.vendorName+" ("+data.content.vendorCode+")";
                            }else{
                                self.vendor = "-"
                            }
                            self.orderingLoc = data.content.order_location+" ("+data.content.orderLocCode+")";
                            self.assignLoc = data.content.assigned_location+" ("+data.content.assignLocCode	+")";
                            self.shipToLoc = data.content.shop_location+" ("+data.content.shipLocCode+")";

                            self.order_location_id = data.content.ordering_location_id;
                            self.assign_location_id = data.content.assigned_location_id;
                            self.ship_to_location_id = data.content.ship_to_location_id;
                            if(data.content.chargesTotal){
                                self.chargesTotal = data.content.chargesTotal;
                            }
                            if(data.content.taxTotal){
                                self.taxTotal = data.content.taxTotal;
                            }

                            if(data.content.notes != null){
                                self.notes = data.content.notes;
                            }else{
                                self.notes = "-";
                            }
                            if(data.content.FirstName != null){
                                self.sales_person = self.titleCase(data.content.FirstName + " " + data.content.LastName);
                            }else{
                                self.sales_person = "-";
                            }

                            if(data.content.attention != null){
                                self.attention = data.content.attention;
                            }else{
                                self.attention = "-";
                            }
                            if (data.content.type == 'Equipment-osr') {
                              if(data.content.vehicleDetail != null) {

                                if(data.content.vehicleDetail.customer_unit_no != null && data.content.vehicleDetail.customer_unit_no != '') {
                                  self.vendor_unit_no = data.content.vehicleDetail.customer_unit_no;
                                } else {
                                  self.vendor_unit_no = '-';
                                }
                                if(data.content.vehicleDetail.unit_no != null && data.content.vehicleDetail.unit_no != '') {
                                  self.unit_no = data.content.vehicleDetail.unit_no;
                                } else {
                                  self.unit_no = '-';
                                }
                                if(data.content.vehicleDetail.vin != null && data.content.vehicleDetail.vin != '') {
                                  self.vin = data.content.vehicleDetail.vin;
                                }else {
                                  self.vin = '-';
                                }

                              }


                            }
                            self.woStatus = self.titleCase(data.content.status);
                            self.delivery_date = data.content.delivery_date;
                            self.order_date = data.content.order_date;
                            self.due_date = data.content.due_date;
                            self.unitPrice = data.content.unit_total;
                            self.taxAmount = data.content.tax_total;
                            self.grandTotal = data.content.grand_total;
                            if (data.content.grand_sub_total != undefined) {
                                self.subTotal = data.content.grand_sub_total;
                            }else{
                                self.subTotal = data.content.sub_total;
                            }
                            self.totalTax = data.content.total_tax;
                            if (data.content.grand_sub_total != undefined) {
                                self.total = data.content.grand_total;
                            }else{
                                self.total = data.content.total;
                            }
                            self.isProcessed = data.content.is_processed;
                            self.receiptCreated = data.content.receipt_created;
                            self.billCreated = data.content.bill_created;
                            //gl entry
                            if (data.content.gl != undefined && data.content.gl != null) {
                              self.glArr = data.content.gl;
                            }else{
                              self.glArr = [];
                            }
                            if (data.content.po_receipts != undefined && data.content.po_receipts != null) {
                                self.poReceiptsArr = data.content.po_receipts;
                            }else{
                                self.poReceiptsArr = [];
                            }
                            self.qty_matched = data.content.qty_matched;
                            self.loadPurchaseOrderItem();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'load-view-vendor-po')
                      /*  if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");

                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }*/
                    }
                });
            },
            loadPurchaseOrderItem(){
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/vendor-purchase-order/items/" + segments[3],
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);

                        if (data.status == "success") {

                            self.purchaseOrderItemsArr = [];
                            self.chargeItemArr = [];
                            if(data.content.length>=1) {
                                if (data.content[0].wo_type != undefined && data.content[0].wo_type != null){
                                    self.woType = data.content[0].wo_type;
                                }
                                for (var i = 0; i < data.content.length; i++) {
                                    if (data.content[i].charge_id == null ) {
                                        var unitName = "";
                                        if (data.content[i].unit_no != null && data.content[i].unit_no != "") {
                                            unitName = data.content[i].unit_no;
                                        }
                                        if (data.content[i].unit_name != null && data.content[i].unit_name != "") {
                                            unitName += " | ";
                                            unitName += data.content[i].unit_name;
                                        }
                                        self.purchaseOrderItemsArr.push({
                                            purchase_order_item_id: data.content[i].id,
                                            purchase_order_id: (data.content[i].vendor_purchase_order_id != undefined) ? data.content[i].vendor_purchase_order_id :data.content[i].purchase_order_id,
                                            manufacture_id: (data.content[i].manufacture_id != undefined && data.content[i].manufacture_id != null && data.content[i].manufacture_id != '')?{value: data.content[i].manufacture_id, text: self.titleCase(data.content[i].vmCode + " | " + data.content[i].vmName)}:"-",
                                            model_id: (data.content[i].model_id != undefined && data.content[i].model_id != null && data.content[i].model_id != '')?{value: data.content[i].model_id, text: self.titleCase(data.content[i].vmodelsCode + " | " + data.content[i].vmodelsName)}:"-",
                                            part: (data.content[i].item_id != undefined && data.content[i].item_id != null && data.content[i].item_id != '')?{value: data.content[i].item_id, text: self.titleCase(data.content[i].iCode + " | " + data.content[i].iName)}:"-",
                                            description:data.content[i].description,
                                            year: (data.content[i].year != undefined && data.content[i].year != null && data.content[i].year != '')?data.content[i].year:"-",
                                            quantity: self.amountFormat(data.content[i].quantity,3),
                                            asset_pool_id: (data.content[i].asset_pool_id != undefined && data.content[i].asset_pool_id != null && data.content[i].asset_pool_id != '')?{value: data.content[i].asset_pool_id, text: self.titleCase(data.content[i].vpoolCode + " | " + data.content[i].vpoolDesc)}:"-",
                                            unit_price: self.amountFormat(data.content[i].unit_price,3),
                                            tax_percentage: data.content[i].tax_percentage,
                                            tax_amount: data.content[i].tax_amount,
                                            sub_total: self.amountFormat(data.content[i].sub_total,3),
                                            total: self.amountFormat(data.content[i].total,3),
                                            req_id: data.content[i].requisition_id,
                                            total_format: self.currencyFormat(data.content[i].total,3),
                                            unit_price_format:self.amountFormat(data.content[i].unit_price,3),
                                            gl_account_id: (data.content[i].gl_account_id != undefined && data.content[i].gl_account_id != null && data.content[i].gl_account_id != '')?{value: data.content[i].gl_account_id, text: self.titleCase(data.content[i].glCode + " | " + data.content[i].glDesc)}:"-",
                                            vehicle_id: (data.content[i].item_vehicle_id != undefined && data.content[i].item_vehicle_id != null && data.content[i].item_vehicle_id != '')?{value: data.content[i].item_vehicle_id, text: self.titleCase(unitName)}:"-",
                                            wo_number:(data.content[i].wo_number != undefined && data.content[i].wo_number != null && data.content[i].wo_number != '')?data.content[i].wo_number:'',
                                            line_number:(data.content[i].line_number != undefined && data.content[i].line_number != null && data.content[i].line_number != '')?data.content[i].line_number:'',
                                        })

                                    } else {

                                        if (self.po_type.toLowerCase() == 'sublet po' || self.po_type.toLowerCase() == 'sublet_po') {
                                            self.purchaseOrderItemsArr.push({
                                                purchase_order_item_id: data.content[i].id,
                                                purchase_order_id: (data.content[i].vendor_purchase_order_id != undefined) ? data.content[i].vendor_purchase_order_id :data.content[i].purchase_order_id,
                                                manufacture_id: (data.content[i].manufacture_id != undefined && data.content[i].manufacture_id != null && data.content[i].manufacture_id != '')?{value: data.content[i].manufacture_id, text: self.titleCase(data.content[i].vmCode + " | " + data.content[i].vmName)}:"-",
                                                model_id: (data.content[i].model_id != undefined && data.content[i].model_id != null && data.content[i].model_id != '')?{value: data.content[i].model_id, text: self.titleCase(data.content[i].vmodelsCode + " | " + data.content[i].vmodelsName)}:"-",
                                                part: (data.content[i].item_id != undefined && data.content[i].item_id != null && data.content[i].item_id != '')?{value: data.content[i].item_id, text: self.titleCase(data.content[i].iCode + " | " + data.content[i].iName)}:"-",
                                                description:data.content[i].description,
                                                year: (data.content[i].year != undefined && data.content[i].year != null && data.content[i].year != '')?data.content[i].year:"-",
                                                quantity: data.content[i].quantity,
                                                asset_pool_id: (data.content[i].asset_pool_id != undefined && data.content[i].asset_pool_id != null && data.content[i].asset_pool_id != '')?{value: data.content[i].item_id, text: self.titleCase(data.content[i].vpoolCode + " | " + data.content[i].vpoolDesc)}:"-",
                                                unit_price: data.content[i].unit_price,
                                                tax_percentage: data.content[i].tax_percentage,
                                                tax_amount: data.content[i].tax_amount,
                                                sub_total: data.content[i].sub_total,
                                                total: data.content[i].total,
                                                req_id: data.content[i].requisition_id,
                                                charge_id: (data.content[i].charge_id != undefined && data.content[i].charge_id != null && data.content[i].charge_id != '')?{value: data.content[i].charge_id, text: self.titleCase(data.content[i].charge_name)}:"-",
                                                wo_number:(data.content[i].wo_number != undefined && data.content[i].wo_number != null && data.content[i].wo_number != '')?data.content[i].wo_number:'',
                                                line_number:(data.content[i].line_number != undefined && data.content[i].line_number != null && data.content[i].line_number != '')?data.content[i].line_number:'',
                                            });
                                        }else{
                                            self.chargeItemArr.push({
                                                purchase_order_item_id: data.content[i].id,
                                                purchase_order_id: data.content[i].purchase_order_id,
                                                charge_id: (data.content[i].charge_id != undefined && data.content[i].charge_id != null && data.content[i].charge_id != '')?{value: data.content[i].charge_id, text: self.titleCase(data.content[i].charge_name)}:"-",
                                                quantity: data.content[i].quantity,
                                                unit_price: data.content[i].unit_price,
                                                sub_total: data.content[i].sub_total,
                                                total: data.content[i].total,
                                            })
                                        }
                                    }

                                }
                            }


                            self.purchaseOrderReadingArr = [];
                            if(data.readings != undefined && data.readings.length > 0) {
                              self.purchaseOrderReadingArr = data.readings;
                            }
                            if (self.purchaseOrderItemsArr.length > 1) {
                                self.showTotalSummary = true;
                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'load-view-vendor-po-item')
                    }
                });
            },
            titleCase(str) {
                if ( str == null ) {
                    return "-";
                } else {
                    var value = str.toString();
                    return value.charAt(0).toUpperCase() + value.slice(1);
                }
            },
            activityLogs(){

                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                self.$root.$emit('activity_log_opted','purchase order',segments[3]);
//                self.activityLogsTabValue = "loadList";     // flag value set to loadList so that filters in list work properly.
                self.activetab = 2;
            },
            sendPo(){
                var self = this;

                if ( self.woStatus != 'Open'){

                    if (confirm('Are you sure that you want to send Purchase Order? ')) {
                        self.sendPurchaseOrder();
                    }

                }else{

                    self.sendPurchaseOrder();
                }
            },

            sendPurchaseOrder: function(){
                var self = this;

                var path = window.location.pathname;
                var segments = path.split("/");
                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + '/purchase-order/send',
                    type: "POST",
                    data: {
                    po_id:segments[3]
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.loading = false;
                        if ( data.code == 201){

                            self.$swal('',data.message,'info');
                        }
                        if( data.code == 200){

                            self.$swal('',data.message,'success');

                        }
                            self.loadPurchaseOrder();
                    // self.$router.push('/customer-estimate/view/'+data.content);
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;

                        self.generateStatusCodeMessage(jqXHR,true,'send-vendor-po')

                    }
                });
            },

            downloadPurchaseOrder(){

                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/get-po-template",
                    type: "GET",
                    data: {id:segments[3],
                    flag:'Send with item',
                    task:'download'},
                    headers: this.ajxHeaders,
                    success: function (data) {
                        self.loading = false;

                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = data;
                        link.download = '';
                        link.target = "_blank";
                        link.click();

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.modalLoading = false;
                        self.reqeustSent = 0;

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'download-vendor-po')

                    }
                });

            },
            selectionForOrder: function (evt, item, index) {
                var self = this;
                console.log(evt.target.checked);
                var path = window.location.pathname;
                var segments = path.split("/");

                if (evt.target.checked == true) {

                    self.selecttaskArr.push({
                        reqId: item.req_id,
                        po_id:segments[3],
                        po_item_id: item.purchase_order_item_id,
                        quantity: item.quantity,
                        unit_price:item.unit_price,
                        ordering_location_id:self.order_location_id,
                        assigned_location_id:self.assign_location_id,
                        ship_to_location_id:self.ship_to_location_id,
                        delivery_date:self.delivery_date
                    });

                } else {
                    // var i = self.selecttaskArr.indexOf(item.woiId);
                    // console.log(i);
                    const filteredItems = self.selecttaskArr.filter(function (task) {
                        return task.po_item_id !== item.purchase_order_item_id;
                    })
                    self.selecttaskArr = filteredItems;
                }
                console.log(self.selecttaskArr);

            },

            processOrder: function(flag){
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");

                $.ajax({
                    url: process.env.ROOT_API + '/process-po',
                    type: "POST",
                    data:{
                        po_id:segments[3],
                        flag:flag
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        console.log("TYPE==", self.po_type);
                        if (flag == 'unprocess'){
                            self.loadPurchaseOrder();
                        }else{
                            self.loading = false;
                            if(self.po_type === "Equipment-osr") {
                                // self.$router.push({ name: 'PurchaseOrderAllList' });
                                self.$router.push("/vendor-purchase-order/view/"+segments[3]);
                                self.loadPurchaseOrder();
                            } else if(self.po_type.toLowerCase() == 'equipment'){
                            }else{
                                if(self.po_type.toLowerCase() == "item" ) {
                                    if (data.content == "part-error") {
                                        self.$swal('',data.message,'info');
                                        return;
                                    }
                                }
                                self.loadPurchaseOrder();
                            }
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;

                        self.generateStatusCodeMessage(jqXHR,true,'process-vendor-po')
                    }
                });
            },
            recordReceipt:function(){
                var self = this;

                var path = window.location.pathname;
                var segments = path.split("/");
                var listPoUrl = self.$route.query.fromUrl;
                if (listPoUrl == undefined || listPoUrl == null || listPoUrl == "") {
                    listPoUrl = self.fromUrl;
                }

                var url = '&id=' + segments[3] + '&type=' + self.po_type+'&redirectFrom=poview&poList='+listPoUrl;
                self.$router.push({ name: 'RecordReceipt', query: { data : btoa(url) }});
            },
            vendorInvoice:function(){
                var self = this;

                var path = window.location.pathname;
                var segments = path.split("/");

                var url = '&id=' + segments[3] + '&type=' + self.po_type+'&redirectFrom=poview';
                self.$router.push({ name: 'BillCreate', query: { data : btoa(url) }});
            },
            addVendorInvoice(receipt_id,po_id){
                var self = this;
                var url = '&id=' + po_id +'&receipt_id=' + receipt_id + '&type=' + self.po_type.toLowerCase()+'&redirectFrom=poreceipttab';
                self.$router.push({ name: 'BillCreate', query: { data : btoa(url) }});
            },
            // previewBarcode
            previewBarcode(){
                var self = this;
                self.selectedRows_data = self.poNum;
                self.selectedRows.push(self.$route.query.id)
                self.showBarcode = true;
            },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/VendorPurchaseOrderView.vue